import { Button, Stack, Typography } from '@mui/material';
import { SharedDialog } from 'customer-management/customer-details/view-contracts/dialogs';
import { DialogCommentField } from 'customer-management/customer-details/view-contracts/dialogs/dialog-comment-field';
import { useViewContractsState } from 'customer-management/customer-details/view-contracts/state/view-contracts-state';
interface RequestDialogProps {
  loading: boolean;
}
export function RequestDialog({ loading }: RequestDialogProps) {
  const state = useViewContractsState();
  return (
    <SharedDialog
      open={state.requestDialog.get()}
      title='Submit Contract Changes for Approval'
      onCancel={() => {
        state.merge({
          requestDialog: false,
          comments: '',
        });
      }}
      submit={
        <Button disabled={loading} form='contract-form' type='submit' variant='contained' color='secondary'>
          Submit Changes
        </Button>
      }
    >
      <Stack spacing={1}>
        <Typography>You are about to submit changes for approval.</Typography>
        <Typography>Please leave a comment on the reason for this change</Typography>
        <DialogCommentField />
      </Stack>
    </SharedDialog>
  );
}
